import type { WaterSolutionGasRswCalculator } from "../d";
export const waterSolutionGasRswCalculator: WaterSolutionGasRswCalculator =
  params => {
    const {
      temperatureF,
      inSituPressurePSIA,
      gasOilRatioSCFSTB,
      oilPhaseGasSolubilitySCFSTB
    } = params;
    const a =
      8.15839 -
      0.0612265 * temperatureF +
      0.000191663 * (temperatureF * temperatureF);
    const b =
      0.0101021 -
      0.0000744241 * temperatureF +
      0.000000305553 * temperatureF * temperatureF -
      0.000000000294883 * temperatureF * temperatureF * temperatureF;
    const c =
      (-9.02505 +
        0.130237 * temperatureF -
        (8.53425 * temperatureF * temperatureF) / 10000 +
        (2.34122 * temperatureF * temperatureF * temperatureF) / 1000000 -
        (2.37049 * temperatureF * temperatureF * temperatureF * temperatureF) /
          1000000000) /
      10000000;

    const rsw =
      a + b * inSituPressurePSIA + c * inSituPressurePSIA * inSituPressurePSIA;
    const min_check = gasOilRatioSCFSTB - oilPhaseGasSolubilitySCFSTB;
    let waterPhaseGasSolubilitySCFSTB = 0;
    if (rsw > min_check) {
      waterPhaseGasSolubilitySCFSTB = min_check;
    } else {
      waterPhaseGasSolubilitySCFSTB = rsw;
    }
    return {
      waterPhaseGasSolubilitySCFSTB,
      a,
      b,
      c
    };
  };
